<div class="block">
  @if (!hideFileName) {
    <div class="left" [style.width]="width + 'px'" style="overflow: hidden; padding: 0 5px; height: 24px; line-height: 24px; border: 1px solid #CECECE; margin-right: 10px;">@if (file) {
      <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap" tooltip [tooltipTitle]="file.name" [tooltipRequiresTruncation]="true" [tooltipVerticalOffset]="6"><span>{{file.name}}</span></div>
    }</div>
  }
  <input pInputText #fileInput hidden="true" type="file" onclick="this.value=null" (change)="onChange($event)">
  <div class="left buttonSet"><button class="btn-medium-secondary" (click)="fileInput.click()" [disabled]="disabled">Browse</button></div>
  <br class="clear"/>
</div>
